import axios from "axios"
const instance = axios.create({
	baseURL: "https://api.cms.riesun.cn",
	timeout: 30000,
	headers: {
		'Content-Type': 'application/json;charset=utf-8;',
		'siteid': 'riesun_site_2eace1215c3b4fd6a5a3f9819fe0f1e8',
		'sitesecret': '654c6aae-a752-430d-b0be-15e020dc1723',
		'User-Request-Type': 'riesun_site'
	}
})

instance.interceptors.request.use((config) => {
	return config;
})
instance.interceptors.response.use((response) => {
	return Promise.resolve(response.data)
})

export default instance;